import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import BlogList from '../components/blog-list'
import Footer from '../components/footer'
import IntegrationsNav from '../components/integrations-nav'
import { getCanonicalUrl } from '../utils/canonical'
import './blog.css'

const Blog = () => {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="blog-view-container">
      <Helmet>
        <title>Blog - SMS Marketing Insights | DataFlows</title>
        <link rel="canonical" href={getCanonicalUrl('/blog')} />
        <meta name="description" content="Stay updated with the latest insights, tips, and trends in SMS marketing and business communication. Learn how to boost customer engagement and grow your business." />
        <meta property="og:title" content="Blog - SMS Marketing Insights | DataFlows" />
        <meta property="og:description" content="Stay updated with the latest insights, tips, and trends in SMS marketing and business communication." />
        <meta property="og:type" content="website" />
        <meta name="keywords" content="SMS marketing blog, business communication, customer engagement, marketing tips, SMS strategy" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://dataflows.com.au/" },
            { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://dataflows.com.au/blog" }
          ]
        })}</script>
      </Helmet>

      <nav className={`bpv-nav${scrolled ? ' bpv-nav--scrolled' : ''}`}>
        <div className="bpv-nav-inner">
          <Link to="/" className="bpv-nav-logo">
            <img src="/dataflows-high-resolution-logo-200h.png" alt="DataFlows" height="34" />
          </Link>
          <div className="bpv-nav-links">
            <a href="/#features">Features</a>
            <a href="/#pricing">Pricing</a>
            <Link to="/blog">Blog</Link>
            <IntegrationsNav />
            <Link to="/developers">Developers</Link>
            <Link to="/contact-us">Contact Us</Link>
          </div>
          <div className="bpv-nav-actions">
            <a href="https://sms.dataflows.com.au" target="_blank" rel="noreferrer noopener" className="bpv-sign-in">Sign in</a>
            <a href="https://sms.dataflows.com.au/register" target="_blank" rel="noreferrer noopener" className="bpv-get-started">Get started</a>
          </div>
        </div>
      </nav>

      <main className="blog-view-main">
        <BlogList />
      </main>

      <Footer />
    </div>
  )
}

export default Blog
